import React, { useEffect, useState } from 'react';
import { Descriptions, Image, Typography, Button, Space, Modal, message } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, EyeOutlined } from '@ant-design/icons';
import moment from 'moment';
import FormSetup from '../../../../../components/Forms/FormSetup';
import { MasterConfigs } from '../../../../../interfaces/entity';
import { useDispatch } from 'react-redux';
import { postData, putData } from '../../../../../actions/developer';

const { Title } = Typography;

// Utility function to get file extension
const getFileType = (value: string): 'image' | 'pdf' | 'text' => {
    if (!value) return 'text';
    const ext = value.split('.').pop()?.toLowerCase();

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) return 'image';
    if (ext === 'pdf') return 'pdf';
    return 'text';
};

const DocumentsView = ({ data, onRefresh }: { data: any[], onRefresh?: Function }) => {
    const [pdf, setPDF] = React.useState<string | null>(null);
    const [formDataId, setFormDataId] = useState(null)
    const dispatch = useDispatch();

    if (!data || data.length === 0) return null;

    const config: MasterConfigs = {
        modalTitle: () => 'Add Reject Comment',
        getFormColumns: () => [
            {
                label: 'Reject Comment',
                name: 'comment',
                type: 'textarea',
                span: 16,
                rules: [{ required: true, message: 'Comment is required' }]
            }
        ],
        onSubmit: async (id, data) => {
            return await onApproveAndReject(formDataId, 'reject', data.comment)
        }
    }

    function isValidDate(text) {
        const date = new Date(text);
        return !isNaN(date.getTime());
    }


    const onAction = async (id, status) => {
        if ('reject' == status) {
            setFormDataId(id)
        } else {
            onApproveAndReject(id, status)
        }
    }

    const onApproveAndReject = async (id, status, comment = null) => {
        try {
            const resData = await dispatch(putData('/form-data-admin/' + id, { approverComment: comment, isApproved: status == 'approve' }))
            if (resData) {
                if (onRefresh)
                    onRefresh()
                return {
                    code: 200, message: 'success'
                }
            }
        } catch (error) {
            return { code: 400, message: 'Faild to update' }
        }
    }

    const onNotify = async (id, configId) => {
        try {
            const resData = await dispatch(postData('/form-data-admin/notify/' + id + '/' + configId, {}))
            if (resData) {
                message.success('Notification sent successfully');
            }
        }
        catch (error) {
            message.error('Failed to send notification');
        }
    }

    return (
        <div className='p-2 space-y-4'>
            <FormSetup config={config} open={formDataId} onClose={() => setFormDataId(null)} isModal={true} />
            <Modal
                title="PDF Preview"
                open={!!pdf}
                onCancel={() => setPDF(null)}
            >
                {pdf && (
                    <iframe
                        src={pdf}
                        width="100%"
                        height="500px"
                        title="PDF Preview"
                    />
                )}
            </Modal>
            {data?.map((ele, index) => <>
                <div key={ele._id} className='flex items-center justify-between'>
                    <Title level={5}>{ele?.formName}</Title>
                    {ele?.formData?.filter(error => error.approverComment).length > 0 && <Button onClick={() => onNotify(ele?.formData[0]?.submiter, ele?._id)} type='link'>
                        Notify Candidate
                    </Button>}
                </div>
                <Descriptions bordered column={1} size='small' key={index}>
                    {ele?.formData.map((item) => {
                        const fileType = getFileType(item.formFieldValue);

                        let content;
                        if (fileType === 'image') {
                            content = <Image width={100} height={100} src={process.env.FILE_URL + item.formFieldValue} alt={item.formFieldLabel} />;
                        } else if (fileType === 'pdf') {
                            content = (
                                <Button type='link' icon={<EyeOutlined />} onClick={() => setPDF(process.env.FILE_URL + item.formFieldValue)} />
                            );
                        } else {
                            content = isValidDate(item.formFieldValue) ? moment(item.formFieldValue).format('DD MMM, YYYY') : item.formFieldValue;
                        }

                        return (
                            <Descriptions.Item
                                key={item._id}
                                label={item.formFieldLabel || item.formField}
                            >
                                <div className='flex justify-between'>
                                    <div style={{ marginBottom: 8 }}>{content}</div>
                                    <Space>
                                        <div className='text-sm text-red-800'>
                                            {item?.approverComment}
                                        </div>
                                        {!item?.isApproved && <Button
                                            type="link"
                                            onClick={() => onAction?.(item._id, 'approve')}
                                            title='Approve'
                                        >Approve</Button>}

                                        <Button
                                            danger
                                            type="link"
                                            onClick={() => onAction?.(item._id, 'reject')}
                                            title='Reject'
                                        >Reject</Button>
                                    </Space>
                                </div>
                            </Descriptions.Item>
                        );
                    })}
                </Descriptions >
            </>)}
        </div>
    );
};

export default DocumentsView;
